import type { DoneInvokeEvent } from 'xstate'

import type { GetCustomerRequestSellerActionsResponse } from '~/api/care-folders/types/seller-actions'
import type { OrderlineRequest } from '~/api/seller-after-sales/types'

import type { MachineContext } from '../ActionBar.machine.type'

export const storeActionsAndRequests = (
  context: MachineContext,
  event: DoneInvokeEvent<
    [GetCustomerRequestSellerActionsResponse, OrderlineRequest[]]
  >,
): MachineContext => {
  const actionsData = event.data[0]
  const requestsData = event.data[1]

  const actions = {
    isRefundAllowed: actionsData.refund?.allowed ?? false,
    isRefundDisabled: actionsData.refund?.disabled ?? false,
    isCustomerBlocked: actionsData.refund?.isCustomerBlocked ?? false,
    isOpenRequestAllowed: actionsData.setOpen ?? false,
    isReportProblemAllowed: actionsData.problem?.declare.allowed ?? false,
    isReportProblemDisabled: actionsData.problem?.declare.disabled ?? false,
    isSendMessageAllowed:
      (actionsData.postMessage?.allowed &&
        !actionsData.postMessage?.replyToAgent) ??
      false,
    isReplyToAgentAllowed:
      (actionsData.postMessage?.allowed &&
        actionsData.postMessage?.replyToAgent) ??
      false,
    isShipBackToCustomerAllowed:
      actionsData.createManualReturnOfProductReturn ?? false,
  }

  const refundInfo = {
    maxRefundPrice: actionsData.refund?.refundPrice,
    isPartialRefundAllowed: actionsData.refund?.allowedPartial,
    partialRefundReasons: actionsData.refund?.partialRefundReasons,
  }

  const reportProblemInfo = {
    problemTypes: actionsData.problem?.declare.types,
  }

  const pendingProblems = actionsData.problem?.pending

  const sendMessageInfo = {
    shouldReportProblem: actionsData.postMessage?.reportProblem,
  }

  return {
    actions,
    requests: requestsData,
    refundInfo,
    reportProblemInfo,
    pendingProblems,
    sendMessageInfo,
  }
}
